var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgExitFullScreen(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "exitFullScreen_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "exitFullScreen_svg__st0",
    d: "M7.4 1.6c-.3 0-.5.2-.5.5v4L.9.2C.8 0 .7 0 .5 0S.3 0 .2.2C0 .4 0 .7.2.9l5.9 5.9h-4c-.3 0-.5.2-.5.5s.2.5.5.5h4.2c.9 0 1.6-.7 1.6-1.6V2.1c0-.3-.2-.5-.5-.5zM13.7 7.9h4.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4L19.8 1c.2-.2.2-.5 0-.7 0-.3-.2-.3-.3-.3s-.3 0-.4.2l-5.9 5.9v-4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v4.2c-.1.9.6 1.6 1.5 1.6zM13.9 13.2h4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4.2c-.9 0-1.6.7-1.6 1.6V18c0 .3.2.5.5.5s.5-.2.5-.5v-4l5.9 5.9c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-5.8-6zM6.3 12.1H2.1c-.3 0-.5.2-.5.5s.2.5.5.5h4L.2 19c-.2.2-.2.5 0 .7.2.2.5.2.7 0l5.9-5.9v4c0 .3.2.5.5.5s.5-.2.5-.5v-4.2c.1-.8-.6-1.5-1.5-1.5z"
  })));
}
export default SvgExitFullScreen;